export default __webpack_public_path__ + "static/media/heart-hg.64876c07.svg";